/**
 * Rearrange a sorted card array so horizontal cards (span 2) don't create gaps.
 * When a horizontal card would land on the last column of a row, swap it with
 * the next vertical card — a minimal 1-position shift that preserves sort order.
 *
 * @param {Array} cards - Sorted array of card objects
 * @param {number} cols - Number of grid columns (e.g. 4)
 * @returns {Array} - New array with horizontal cards repositioned to avoid gaps
 */
export function arrangeCardsForGrid(cards, cols) {
  if (!cols || cols < 2) return cards;
  var result = cards.slice();
  var col = 0;
  for (var i = 0; i < result.length; i++) {
    var isHoriz = result[i].horizontal === true || result[i].cardHorizontal === true;
    if (isHoriz && col + 2 > cols) {
      // Horizontal card doesn't fit — find next vertical card to swap with
      var swapped = false;
      for (var j = i + 1; j < result.length; j++) {
        if (!result[j].horizontal && !result[j].cardHorizontal) {
          var temp = result[i];
          result[i] = result[j];
          result[j] = temp;
          swapped = true;
          break;
        }
      }
      if (!swapped) {
        // No vertical card available — gap is unavoidable, advance to next row
        col = 0;
        col += 2;
        if (col >= cols) col = 0;
        continue;
      }
      // After swap, current card is now vertical
      col += 1;
    } else if (isHoriz) {
      col += 2;
    } else {
      col += 1;
    }
    if (col >= cols) col = 0;
  }
  return result;
}
